import { useMemo } from 'react';
import CodeBlock from '../../CodeBlock';
import type { MdComponentIndexProps } from './type';

export function CodeHighLight(props: { code: string; language: string } & MdComponentIndexProps) {
  const lang = useMemo(() => {
    if (props.language) return props.language;
    // guess language 用模糊匹配优化用户体验
    if (props.code.startsWith('{')) {
      return 'json';
    }
    if (props.code.startsWith('curl')) {
      return 'bash';
    }
    if (props.code.startsWith('<!--') || props.code.startsWith('<')) {
      return 'xml';
    }
    if (props.code.startsWith('<?php')) {
      return 'php';
    }
    if (props.code.startsWith('```')) {
      return 'bash';
    }
    if (props.code.startsWith('/*')) {
      return 'css';
    }
    if (
      props.code.startsWith('let') ||
      props.code.startsWith('const') ||
      props.code.startsWith('export')
    ) {
      return 'javascript';
    }
    return '';
  }, [props.language]);
  return (
    <div
      className="markdown-code-block"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <CodeBlock code={props.code} language={lang} onlyCode={false} />
    </div>
  );
}
